import React from "react";
import Select, { Async, Creatable } from "react-select";
import { RadioGroup, Radio } from "react-radio-group";
import Dialog from "../../../components/dialog";
import Overlay from "../../../components/overlay";
import { getStores } from "../../../backend/stores";

export default function() {
  const {
    confirmDialogVisible,
    uploading,
    loading,
    machines,
    store = { id: 0, name: "No store" },
    reinspectionForm
  } = this.state;

  const { match } = this.props;

  return (
    <div className="form">
      {!reinspectionForm && [
        <label>Store</label>,
        <Async
          loadOptions={getStores}
          value={store}
          onChange={({ value, label }) => {
            this.setState({ store: { value, label } });
            this._navigate(`/comment-form/${value}`)();
          }}
        />
      ]}

      <div className="form">
        {loading && <Overlay />}

        {match.params.store_id &&
          machines.map(
            (
              {
                machine_id,
                machine_code,
                subject_id,
                machine_status,
                status,
                last_inspection_date
              },
              index
            ) => (
              <div className="store-machines form" key={index}>
                <label className={reinspectionForm && "disabled"}>
                  Machine Number: {machine_code}
                </label>
                <label className={reinspectionForm && "disabled"}>
                  Merchandiser Inspection
                </label>
                <RadioGroup
                  className={`radio-group ${reinspectionForm && "disabled"}`}
                  name={`machine-${machine_id || subject_id}`}
                  selectedValue={machine_status || status}
                  onChange={
                    !reinspectionForm &&
                    this._editMachine(index, "radio", "machine_status")
                  }
                >
                  <div>
                    <Radio value={"Available"} /> <span>Avail</span>
                  </div>
                  <div>
                    <Radio value={"On Hire"} /> <span>On Hire</span>
                  </div>
                  <div>
                    <Radio value={"Issue"} /> <span>Issue</span>
                  </div>
                  <div>
                    <Radio value={"Missing"} /> <span>Missing</span>
                  </div>
                </RadioGroup>
                {machine_status === "Issue" ? (
                  <div>
                    <label>Equipment Fault</label>
                    <Creatable
                      placeholder="Select or create"
                      options={[{ value: "Broken", label: "Broken" }]}
                      onChange={
                        !reinspectionForm &&
                        this._change("equipment_fault", true, true)
                      }
                    />
                  </div>
                ) : null}
              </div>
            )
          )}

        <label>Are booking sheets required?</label>
        <RadioGroup
          className={`radio-group ${reinspectionForm && "disabled"}`}
          name={"booking_sheets_required"}
          selectedValue={this.state.booking_sheets_required}
          onChange={
            !reinspectionForm &&
            this._change("booking_sheets_required", true, false)
          }
        >
          <div>
            <Radio value={true} /> <span>Yes</span>
          </div>
          <div>
            <Radio value={false} /> <span>No</span>
          </div>
        </RadioGroup>

        <label className={reinspectionForm && "disabled"}>
          Is there a spare hire book in store?
        </label>
        <RadioGroup
          className={`radio-group ${reinspectionForm && "disabled"}`}
          name={"spare_hire_book"}
          selectedValue={this.state.spare_hire_book}
          onChange={
            !reinspectionForm && this._change("spare_hire_book", true, false)
          }
        >
          <div>
            <Radio value={true} /> <span>Yes</span>
          </div>
          <div>
            <Radio value={false} /> <span>No</span>
          </div>
        </RadioGroup>
        {this.state.spare_hire_book === false && [
          <label>Is a new book required?</label>,
          <RadioGroup
            className={`radio-group ${reinspectionForm && "disabled"}`}
            name={"new_book_required"}
            selectedValue={this.state.new_book_required}
            onChange={
              !reinspectionForm &&
              this._change("new_book_required", true, false)
            }
          >
            <div>
              <Radio value={true} /> <span>Yes</span>
            </div>
            <div>
              <Radio value={false} /> <span>No</span>
            </div>
          </RadioGroup>
        ]}

        <label>Hire dockets collected (in sequence)</label>
        <RadioGroup
          className={`radio-group ${reinspectionForm && "disabled"}`}
          name={"hire_dockets_collected"}
          selectedValue={this.state.hire_dockets_collected}
          onChange={
            !reinspectionForm &&
            this._change("hire_dockets_collected", true, false)
          }
        >
          <div>
            <Radio value={true} /> <span>Yes</span>
          </div>
          <div>
            <Radio value={false} /> <span>No</span>
          </div>
        </RadioGroup>
        {this.state.hire_dockets_collected === true ? (
          <div className="docket-container">
            <input
              onChange={event =>
                this.setState({ docket_start: event.target.value })
              }
            />
            to{" "}
            <input
              onChange={event =>
                this.setState({ docket_end: event.target.value })
              }
            />
          </div>
        ) : this.state.hire_dockets_collected === false ? (
          [
            <label>Explain</label>,
            <Creatable
              placeholder="Select or create"
              options={[{ value: "No hires", label: "No hires" }]}
              onChange={
                !reinspectionForm && this._change("dockets_explain", true, true)
              }
            />
          ]
        ) : null}

        <label>Have Rug Doctor requested additional dockets?</label>
        <RadioGroup
          className={`radio-group ${reinspectionForm && "disabled"}`}
          name={"all_equipment_okay"}
          selectedValue={this.state.additional_dockets_requested}
          onChange={
            !reinspectionForm &&
            this._change("additional_dockets_requested", true, false)
          }
        >
          <div>
            <Radio value={true} /> <span>Yes</span>
          </div>
          <div>
            <Radio value={false} /> <span>No</span>
          </div>
        </RadioGroup>
        {this.state.additional_dockets_requested === true
          ? [
              <label>Hire dockets requested</label>,
              <input
                onChange={event =>
                  this.setState({ additonal_dockets: event.target.value })
                }
              />
            ]
          : null}

        {/* <label className={reinspectionForm && "disabled"}>
          All equipment accounted for and in working order?
        </label>
        <RadioGroup
          className={`radio-group ${reinspectionForm && "disabled"}`}
          name={"all_equipment_okay"}
          selectedValue={this.state.all_equipment_okay}
          onChange={
            !reinspectionForm && this._change("all_equipment_okay", true, false)
          }
        >
          <div>
            <Radio value={true} /> <span>Yes</span>
          </div>
          <div>
            <Radio value={false} /> <span>No</span>
          </div>
        </RadioGroup>

        <label className={reinspectionForm && "disabled"}>Priority</label>
        <Select
          value={{ value: this.state.priority, label: this.state.priority }}
          options={[
            { value: "None", label: "None" },
            { value: "Low", label: "Low" },
            { value: "Medium", label: "Medium" },
            { value: "High", label: "High" }
          ]}
          onChange={!reinspectionForm && this._change("priority", true, true)}
        />

        <label className={reinspectionForm && "disabled"}>
          Requires action?
        </label>
        <RadioGroup
          className={`radio-group ${reinspectionForm && "disabled"}`}
          name={"require_action"}
          selectedValue={this.state.require_action}
          onChange={
            !reinspectionForm && this._change("require_action", true, false)
          }
        >
          <div>
            <Radio value={true} /> <span>Yes</span>
          </div>
          <div>
            <Radio value={false} /> <span>No</span>
          </div>
        </RadioGroup> */}

        <label className={reinspectionForm && "disabled"}>
          Additional comments
        </label>
        <textarea
          value={this.state.inspection_note}
          onChange={!reinspectionForm && this._change("inspection_note")}
        />

        {reinspectionForm && [
          <label>Action completed?</label>,
          <RadioGroup
            className="radio-group"
            name={"complete"}
            selectedValue={this.state.complete}
            onChange={this._change("complete", true, false)}
          >
            <div>
              <Radio value={true} /> <span>Yes</span>
            </div>
            <div>
              <Radio value={false} /> <span>No</span>
            </div>
          </RadioGroup>,
          <label>Note</label>,
          <textarea
            value={this.state.added_note}
            onChange={this._change("added_note")}
          />
        ]}

        <button disabled={!this._valid()} onClick={this._toggleConfirmDialog}>
          Update Comment
        </button>
        {confirmDialogVisible && (
          <Dialog close={this._toggleConfirmDialog}>
            <div>
              <h4>You are completing the action.</h4>
              <p>
                This will notify RugDoctor that the action has been completed.
                This inspection will no longer be editable
              </p>
              <div className="button-group">
                <button onClick={this._toggleConfirmDialog}>No</button>
                <button
                  onClick={() => {
                    this._toggleConfirmDialog();
                    this._upload();
                  }}
                >
                  Yes
                </button>
              </div>
            </div>
          </Dialog>
        )}
      </div>
      {uploading && <Dialog loader />}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/screens/stores/comment-form/view.js